<div class="postavitev-info" [style.background]="this.barva">
  {{ this.besedilo }}
</div>
